import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { sixScenes } from '@/mocks/jiuchou-architecture';

export default function ScenarioLayer() {
  return (
    <section className="w-full bg-foreground-950 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            dark
            eyebrow="第二层 · 业务场景层"
            title="不只是商城，而是六大业务场景"
            subtitle="数字买货、数字卖货、数字服务、数字聚餐、数字供应链、数字消费权益——九畴云铺是一套县域商业场景集合。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {sixScenes.map((s, i) => (
            <Reveal key={s.no} delay={i * 70}>
              <div className="h-full p-6 rounded-lg bg-foreground-900 border border-foreground-700 hover:border-accent-400/50 transition-colors">
                <div className="flex items-center justify-between">
                  <div className="w-12 h-12 rounded-lg bg-accent-500/20 flex items-center justify-center">
                    <i className={`${s.icon} text-accent-300 text-2xl`}></i>
                  </div>
                  <span className="font-heading font-bold text-2xl text-foreground-700">{s.no}</span>
                </div>
                <h3 className="mt-4 font-heading font-bold text-lg text-background-50">{s.name}</h3>
                <p className="mt-2 text-sm text-foreground-300 leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}